import React from 'react';
import PropTypes from 'prop-types';

const LoadingSpinner = (props) => {
  return (
    <div
      style={props.height ? { minHeight: `${props.height}px`, height: 'auto' } : null}
      className={`fe-loading-container relative ${props.fit ? 'fit' : ''}`}
    >
      <div className="lds-dual-ring"><div></div><div></div><div></div><div></div></div>
    </div>
  );
};

LoadingSpinner.propTypes = {
  fit: PropTypes.bool.isRequired,
  height: PropTypes.number,
};

LoadingSpinner.defaultProps = {
  fit: false,
};

export default LoadingSpinner;